var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 226.24 150.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #eccb00;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #110bff;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u0421\\u043B\\u043E\\u0439_1-2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "33.74 34.13 33.74 103.84 25.69 111.96 25.69 34.13 33.74 34.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m46.4,14.95v66.55c-1.81,2.64-2.88,5.83-2.88,9.26,0,.99.09,1.98.27,2.95l-5.44,5.49V14.95h8.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m59.05,1.15v73.24c-2.96.15-5.71,1.1-8.05,2.62V1.15h8.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m71.71,19.94v59.45c-2.15-2.23-4.93-3.86-8.05-4.59V19.94h8.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "84.36 12.65 84.36 102.34 76.31 94.28 76.31 12.65 84.36 12.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m97.01,32.59v79.07c-.94.1-1.87.29-2.77.55l-5.28-5.28V32.59h8.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m109.67,18.98v85.16l-6.97,7.88c-.36-.09-.72-.16-1.08-.22V18.98h8.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "122.32 1.15 122.32 89.82 114.27 98.93 114.27 1.15 122.32 1.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m134.98,17.83v46.89c-1.7,2.58-2.68,5.67-2.68,8.98,0,1.44.18,2.85.55,4.22l-5.92,6.7V17.83h8.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m147.63,4.98v52.36c-2.97.19-5.72,1.17-8.05,2.73V4.98h8.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m160.28,23.97v38.16c-2.17-2.18-4.95-3.75-8.05-4.43V23.97h8.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m172.94,43.33v37.49c-1.06.13-2.11.36-3.12.7l-4.93-4.79v-33.4h8.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m185.59,5.18v67.26l-7.24,8.62c-.27-.06-.54-.11-.82-.15V5.18h8.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m198.25,45.55c-.62,1.73-.96,3.59-.96,5.52s.33,3.76.96,5.52v.76l-8.05,9.59V0h8.05v45.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m165.08,73.7c0,.84-.06,1.68-.19,2.5v-5.01c.13.82.19,1.65.19,2.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m213.68,38.52c-6.94,0-12.56,5.62-12.56,12.56,0,2.42.69,4.68,1.87,6.59l-23.32,27.78c-1.46-.59-3.05-.92-4.72-.92-2.16,0-4.2.55-5.98,1.51l-8.44-8.19c.46-1.3.71-2.7.71-4.15,0-6.94-5.62-12.56-12.56-12.56s-12.56,5.62-12.56,12.56c0,1.81.39,3.53,1.07,5.08l-33.31,37.68c-1.55-.68-3.26-1.06-5.06-1.06-1.99,0-3.87.47-5.54,1.29l-21.59-21.59c.5-1.35.77-2.81.77-4.34,0-6.94-5.62-12.56-12.56-12.56s-12.56,5.62-12.56,12.56c0,1.44.24,2.82.69,4.1l-30.85,31.1c-1.44-.57-3-.89-4.64-.89-6.94,0-12.56,5.62-12.56,12.56s5.62,12.56,12.56,12.56,12.56-5.62,12.56-12.56c0-1.77-.37-3.46-1.03-4.99l30.34-30.59c1.66.81,3.52,1.26,5.5,1.26s3.68-.42,5.28-1.17l21.75,21.75c-.43,1.27-.67,2.63-.67,4.05,0,6.94,5.62,12.56,12.56,12.56s12.56-5.62,12.56-12.56c0-1.6-.3-3.13-.85-4.54l33.6-38.01c1.41.55,2.94.85,4.54.85,1.96,0,3.81-.45,5.46-1.25l8.77,8.51c-.34,1.13-.52,2.33-.52,3.57,0,6.94,5.62,12.56,12.56,12.56s12.56-5.62,12.56-12.56c0-1.73-.35-3.39-.99-4.89l24.26-28.91c.93.22,1.9.34,2.89.34,6.94,0,12.56-5.62,12.56-12.56s-5.62-12.56-12.56-12.56Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgData);
export default __webpack_public_path__ + "static/media/data.a1cc08b1c3a5ab7efb7327c7df12a8a5.svg";
export { ForwardRef as ReactComponent };